module.exports = __webpack_public_path__ + "media/images/admin/icons/slash-40c1c466364449c6421e3b613b4f3166.svg";